import { render, staticRenderFns } from "./MultiSelectRoles.vue?vue&type=template&id=0b36bd61"
import script from "./MultiSelectRoles.vue?vue&type=script&lang=js"
export * from "./MultiSelectRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports